module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "gForm",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label-position": "right",
      "label-width": "12.5%",
      "model": _vm.submitForm,
      "rules": _vm.editRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.name'),
      "prop": "roleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.roleName),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "roleName", $$v)
      },
      expression: "submitForm.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.mark'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.submitForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.submitForm, "memo", $$v)
      },
      expression: "submitForm.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('menuConfig.role.modelSelect'),
      "prop": "memo"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "show-checkbox": "",
      "data": _vm.resultData,
      "props": _vm.defaultProps,
      "node-key": "menuId",
      "default-expand-all": "",
      "expand-on-click-node": false
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "width": "60%",
      "margin-top": "10px"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.checkAll()
      }
    }
  }, [(!_vm.alreadyCheckAll) ? [_vm._v(_vm._s(_vm.$t('mao_global.btn.selectAll')))] : [_vm._v(_vm._s(_vm.$t('mao_global.btn.unSelectAll')))]], 2), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.reset')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addRole()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('mao_global.btn.createNow')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f0b9af0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/role-add.vue
// module id = 989
// module chunks = 0